import type {AxiosInstance} from "axios";
import {type ListEndpoint, listEndpoint} from "./util/ListEndpoint";
import {type MetlVersionApi, metlVersionApi} from "./MetlVersionApi.ts";
import {metlScheduleApi, type MetlScheduleApi} from "./MetlScheduleApi.ts";
import type {MetlScheduleExport} from "../metl-models/exports/MetlScheduleExport.ts";
import type {MetlProjectDebug} from "../metl-models/debug/MetlProjectDebug.ts";
import {type MetlTaskHistoryApi, taskHistoryApi} from "./MetlTaskHistoryApi.tsx";
import type {MetlEnvironmentExport} from "../metl-models/exports/MetlEnvironmentExport.ts";
import {metlGitApi, type MetlGitApi} from "./MetlGitApi.ts";

export interface MetlProjectApi {
    id: string
    versions: ListEndpoint<MetlVersionApi>
    schedule: ListEndpoint<MetlScheduleApi, MetlScheduleExport>
    environment: ListEndpoint<undefined, MetlEnvironmentExport>
    git: ()=>MetlGitApi
    taskHistory: ()=>MetlTaskHistoryApi
    debug: () => Promise<MetlProjectDebug>
}

export function metlProjectApi(axios: AxiosInstance, baseUrl: string, id: string): MetlProjectApi {
    return {
        id: `${id}/baseUrl`,
        versions: listEndpoint(axios, `${baseUrl}/versions`, `${id}/versions`, metlVersionApi),
        schedule: listEndpoint(axios, `${baseUrl}/schedule`, `${id}/schedule`, metlScheduleApi),
        environment: listEndpoint(axios, `${baseUrl}/environment`, `${id}/environment`, ()=>undefined),
        git: ()=>metlGitApi(axios, baseUrl, id),
        taskHistory: ()=>taskHistoryApi(axios, `${baseUrl}/task`, `${id}/task`),
        debug: async () => await axios.get<MetlProjectDebug>(`${baseUrl}/debug`).then(r => r.data)
    }
}